export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  practiceAreas: "nav-practice-areas",
  practiceDropdown: "nav-practice-dropdown",
  linkAbout: "nav-link-about",
  linkInsights: "nav-link-insights",
  linkContact: "nav-link-contact",
  bookCta: "nav-book-consultation",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  section: "hero-section",
  headline: "hero-headline",
  subhead: "hero-subhead",
  cta: "hero-cta",
  video: "hero-video",
};

export const CREDENTIALS = {
  strip: "credentials-strip",
  stat: "credential-stat",
};

export const FOOTER = {
  section: "footer-section",
  firmName: "footer-firm-name",
  address: "footer-address",
  email: "footer-email",
  linkedin: "footer-linkedin",
  bookCta: "footer-book-consultation",
};

export const HOME = {
  emergentLink: "emergent-link",
};
